/**
 * Breakpoints
 * XS = extra small
 * SM = small
 * MD = middle
 * LG = large
 * XL = extra large
 */
export const BP_XS = 480
export const BP_SM = 768
export const BP_MD = 992
export const BP_LG = 1200
export const BP_XL = 1360

/**
 * Media queries
 */
export const MEDIA_MIN_XS = `@media (min-width: ${BP_XS}px)`
export const MEDIA_MIN_SM = `@media (min-width: ${BP_SM}px)`
export const MEDIA_MIN_MD = `@media (min-width: ${BP_MD}px)`
export const MEDIA_MIN_LG = `@media (min-width: ${BP_LG}px)`
export const MEDIA_MIN_XL = `@media (min-width: ${BP_XL}px)`

export const MEDIA_MAX_XS = `@media (max-width: ${BP_XS}px)`
export const MEDIA_MAX_SM = `@media (max-width: ${BP_SM}px)`
export const MEDIA_MAX_MD = `@media (max-width: ${BP_MD}px)`
export const MEDIA_MAX_LG = `@media (max-width: ${BP_LG}px)`
export const MEDIA_MAX_XL = `@media (max-width: ${BP_XL}px)`
